import orientation from '@/helpers/rave/constants/baseOrientations'

export default {
  [orientation.SINGULAR]: 'Singular',
  [orientation.FOCUSED]: 'Focused',
  [orientation.BINARY]: 'Binary',
  [orientation.BINARY_SEPARATION]: 'Binary Separation'
}
